import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { SectionHeader } from '../ui/Shared';
export function LearnSection() {
  const deliverables = [{
    title: 'Guía Principal SOS Reflujo 11 PM',
    desc: 'El paso a paso exacto para apagar la acidez en minutos.'
  }, {
    title: 'El Método de Purificación de Sábila',
    desc: 'Cómo extraer el cristal correctamente (sin el tóxico amarillo) para sanar tu esófago.'
  }, {
    title: 'La Fórmula de Hidratación Peso/7',
    desc: 'Cuánta agua exacta necesita TU cuerpo para crear su propio antiácido.'
  }, {
    title: 'Lista de los 5 Gatillos Silenciosos',
    desc: 'Los alimentos "sanos" que debes eliminar hoy mismo para dejar de quemarte.'
  }, {
    title: 'La Guía de Posicionamiento Nocturno',
    desc: 'Cómo usar la gravedad y el lado izquierdo para que el ácido no suba nunca más.'
  }, {
    title: 'Checklist de 20 Días',
    desc: 'Un calendario de seguimiento para asegurar tu recuperación completa.'
  }];
  return <section id="que-recibes" className="py-24 bg-surface" data-id="element-253">
      <div className="max-w-[1100px] mx-auto px-6" data-id="element-254">
        <SectionHeader tag="Lo que obtienes" title={<>
              Todo lo que necesitas para
              <br data-id="element-256" />
              recuperar tus noches
            </>} data-id="element-255" />

        <div className="stagger-children grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-12" data-id="element-257">
          {deliverables.map((item, idx) => <div key={idx} className="flex items-start gap-4 p-6 bg-secondary border border-white/5 rounded-xl transition-all duration-300 hover:border-accent/30 hover:-translate-y-1" data-id="element-258">
              <CheckCircle2 className="w-6 h-6 text-accent shrink-0 mt-0.5" data-id="element-259" />
              <div data-id="element-260">
                <h3 className="text-base font-bold text-text-light mb-2 leading-tight" data-id="element-261">
                  {item.title}
                </h3>
                <p className="text-sm text-text-muted leading-relaxed" data-id="element-262">
                  {item.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}